/*global define, dna*/
define('core/services/TestsService',['angular'], function(angular) {
    'use strict';
    angular.module('dnaApp').service('TestsService', ['$q', '$log', '$http', '$timeout', 'CacheFactory', '$rootScope', function($q, $log, $http, $timeout, CacheFactory, $rootScope) {
        /********
         * PRIVATE METHODS AND FUNCTIONS
         *******/
        var testsServiceLongCache = CacheFactory('testsServiceLongCache', {maxAge: 14400000}); // Keep items for only 4 hours
        var testsServiceShortCache = CacheFactory('testsServiceShortCache', {maxAge: 3600000}); // Keep items for only 1 hours
        var testsServiceImageCache = CacheFactory('testsServiceImageCache', {maxAge: 3600000}); // Keep items for only 1 hours
        var lastViewedTest;
        var KEY_GUID = 'TEST-GUID';
        var URL_ETHNICITY = '/secure/tests/' + KEY_GUID + '/ethnicity';
        var URL_LINK = '/secure/tests/' + KEY_GUID + '/treeLinkDetails';
        var URL_PARENTS = '/secure/tests/' + KEY_GUID + '/treeParents';
        var URL_PERSON = '/secure/tests/' + KEY_GUID + '/treePersonDetails';
        var URL_ORDERS = '/secure/orders';
        var URL_COUNT = '/secure/orders/count';
        var URL_TESTS = '/secure/tests';
        var URL_ALL_TESTS_COUNT = '/allTestCount/';
        var URL_DNA_PROCESSING_TIME_EST = '/secure/tests/' + KEY_GUID + '/dnaProcessingTimeEstimates';

        function setTestDates(testData) {
            if (testData.completeTests) {
                for (var i = 0; i < testData.completeTests.length; i++) {
                    testData.completeTests[i].lastUpdatedDate = new Date(testData.completeTests[i].lastUpdated);
                }
            }
            if (testData.inProgressTests) {
                for (var j = 0; j < testData.inProgressTests.length; j++) {
                    testData.inProgressTests[j].lastUpdatedDate = new Date(testData.inProgressTests[j].lastUpdated);
                }
            }
        }

        function getTestsData(deferred) {
            $http.get(URL_TESTS, {cache: testsServiceShortCache}).success(function (data, status, headers, config) {
                if (data.status === 'SUCCESS') {
                    var testData = data.data;
                    setTestDates(testData);
                    deferred.resolve(testData);
                } else {
                    deferred.reject(data, status, headers, config);
                }
            }).error(function (data, status, headers, config) {
                deferred.reject(data, status, headers, config);
            });
        }

        /**
         * @method findTest
         * @desc Search through the list of tests for one that has a guid matching the provided guid.
         * @param tests an Array of Test objects.
         * @param testGuid The test guid we are looking for
         * @returns {Object} matched test or null if none found
         * @private
         */
        function findTest(tests, testGuid) {
            if (tests) {
                for (var i = 0; i < tests.length; i++) {
                    if (tests[i].guid === testGuid) {
                        return tests[i];
                    }
                }
            }
            return {};
        }

        function _compareOrdersNewFirst(order1, order2) {
            var date1 = order1 && order1.purchaseDate ? order1.purchaseDate : 25200000;
            var date2 = order2 && order2.purchaseDate ? order2.purchaseDate : 25200000;
            return date2 - date1;
        }

        /**
         * @class TestsService
         */
        return {
            lastSelectedTest: null,

            getHomePath: function(goToRoot) {
                if (this.lastSelectedTest && !goToRoot) {
                    return 'insights/' + this.lastSelectedTest;
                } else {
                    return 'insights';
                }
            },



            /**
             * @method getTests
             * @desc Retrieve the lists of activated tests for the logged-in user.
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getTests: function() {
                var deferred = $q.defer();
                if (dna.data.tests) {
                    try {
                        var tests = JSON.parse(dna.data.tests);
                        if (tests !== false) {
                            testsServiceShortCache.put(URL_TESTS, {
                                status: "SUCCESS",
                                data: tests
                            });
                            setTestDates(tests);
                            deferred.resolve(tests);
                        } else {
                            getTestsData(deferred);
                        }
                    } catch (e) {
                        getTestsData(deferred);
                    }
                    delete dna.data["tests"];
                } else {
                    getTestsData(deferred);
                }
                return deferred.promise;
            },
            getTestByTestGuid: function(testGuid) {
                var deferred = $q.defer();
                this.getTests().then(function (data) {
                    var test = findTest(data.completeTests, testGuid);
                    if( angular.equals(test, {}) ) {
                        test = findTest(data.inProgressTests, testGuid);
                    }
                    deferred.resolve(test);
                }).catch(function (data) {
                    deferred.reject(data);
                });
                return deferred.promise;
            },
            getAllTestCount: function(ucdmId){
                var deferred = $q.defer();
                $http.get(URL_ALL_TESTS_COUNT+ucdmId).success(function(data) {
                        deferred.resolve(data);
                }).error(function(data) {
                    deferred.reject(data);
                });
                return deferred.promise;
            },

            getTestEthnicity: function (testGuid, version) {
                var deferred = $q.defer();
                var url = URL_ETHNICITY;

                if (testGuid === undefined) {
                    deferred.reject();
                    return deferred.promise;
                }

                if (version !== undefined) {
                    url += '?v=' + version;
                }

                $http.get(url.replace(KEY_GUID, encodeURIComponent(testGuid))).success(function (data) {
                    deferred.resolve(data);
                }).error(function (data) {
                    deferred.reject(data);
                });

                return deferred.promise;
            },

            removeCachedTreePersonDetails: function(testGuid) {
                var encodedGuid = encodeURIComponent(testGuid);
                testsServiceLongCache.remove(URL_LINK.replace(KEY_GUID, encodedGuid));
                testsServiceLongCache.remove(URL_PERSON.replace(KEY_GUID, encodedGuid));
            },

            getTreeLinkDetails: function(testGuid) {
                var deferred = $q.defer();
                var url = URL_LINK.replace(KEY_GUID, encodeURIComponent(testGuid));
                $http.get(url, {cache: testsServiceLongCache}).success(function (data, status, headers, config) {
                    deferred.resolve(data, status, headers, config);
                }).error(function (data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },

            getTreePersonDetails: function(testGuid) {
                var deferred = $q.defer();
                var url = URL_PERSON.replace(KEY_GUID, encodeURIComponent(testGuid));
                $http.get(url, {cache: testsServiceLongCache}).success(function (data, status, headers, config) {
                    deferred.resolve(data, status, headers, config);
                }).error(function (data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },

            getTreeParents: function (testGuid) {
                var deferred = $q.defer();
                var url = URL_PARENTS.replace(KEY_GUID, encodeURIComponent(testGuid));
                $http.get(url, {cache: testsServiceShortCache}).success(function (data, status, headers, config) {
                    if (data !== null && data !== undefined) {
                        deferred.resolve(data, status, headers, config);
                    } else {
                        deferred.resolve({father: null, mother: null}, status, headers, config);
                    }
                }).error(function (data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },

            getTestSubject: function(testGuid) {
                var deferred = $q.defer();
                if (testGuid) {
                    var url = '/secure/tests/' + encodeURIComponent(testGuid);
                    $http.get(url, {cache: testsServiceImageCache}).success(function(data) {
                        deferred.resolve(data);
                    }).error(function(data) {
                        deferred.reject(data);
                    });
                } else {
                    // We weren't given any actionable data, so just return null (i.e. no image).
                    deferred.resolve(null);
                }
                return deferred.promise;
            },

            clearTestsImageCache: function () {
                testsServiceImageCache.removeAll();
            },

            /**
             * @method clearTestsCache
             * @desc Clears the tests cache.
             * @public
             */
            clearTestsCache: function() {
                testsServiceShortCache.removeAll();
                testsServiceImageCache.removeAll();
                delete dna.data["tests"];
                delete dna.data["orderCount"];
            },

            /**
             * @method getOpenOrders
             * @desc Retrieve the list of orders for the logged-in user.
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getOrderCount: function() {
                var deferred = $q.defer();
                if (dna.data.orderCount) {
                    var orderCount = dna.data.orderCount;
                    testsServiceShortCache.put(URL_COUNT, {
                        status: "SUCCESS",
                        data: orderCount
                    });
                    deferred.resolve(orderCount);
                    delete dna.data["orderCount"];
                } else {
                    $http.get(URL_COUNT, {cache: testsServiceShortCache}).success(function (data, status, headers, config) {
                        if (data.status === 'SUCCESS') {
                            deferred.resolve(data.data);
                        } else {
                            deferred.reject(data, status, headers, config);
                        }
                    }).error(function (data, status, headers, config) {
                        deferred.reject(data, status, headers, config);
                    });
                }
                return deferred.promise;
            },

            /**
             * @method getOpenOrders
             * @desc Retrieve the list of orders for the logged-in user.
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getOrderHistory: function() {
                var deferred = $q.defer();
                $http.get(URL_ORDERS, {cache: testsServiceShortCache}).success(function(data, status, headers, config) {
                    try {
                        data.sort(_compareOrdersNewFirst);
                    } catch (ignore) {}
                    deferred.resolve(data);
                }).error(function(data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },

            /**
             * @method getLegacyTests
             * @desc Retrieve the list of legacy tests for the logged-in user.
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getLegacyTests: function() {
                var deferred = $q.defer();
                var url = '/secure/legacy/meta';
                $http.get(url, {cache: testsServiceLongCache}).success(function(data, status, headers, config) {
                    deferred.resolve(data);
                }).error(function(data, status, headers, config) {
                    deferred.reject(data);
                });
                return deferred.promise;
            },
            
            getCountryRegionInfo: function() {
                var deferred = $q.defer();
                var url = '/secure/tests/regions';
                $http.get(url, {cache: testsServiceLongCache}).success(function(data) {
                    deferred.resolve(data);
                }).error(function(data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },
            
            getCountryRegionInfoByRegion: function(region) {
            	var deferred = $q.defer();
            	var url = '/secure/tests/regions/' + region;
            	$http.get(url, {cache: testsServiceLongCache}).success(function(data) {
            		deferred.resolve(data);
            	}).error(function(data, status, headers, config) {
            		deferred.reject(data, status, headers, config);
            	});
            	return deferred.promise;
            },

            /**
             * @method requestRecollect
             * @desc Request the test with the given activationCode to be recollected.
             * @param {String} testGuid
             * @param {Object} recollectAddress
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            requestRecollect: function(testGuid, recollectAddress) {
                var deferred = $q.defer();
                var url = '/secure/tests/recollect/' + encodeURIComponent(testGuid);
                $http.post(url, recollectAddress).success(function(data) {
                    if (data.status === 'SUCCESS') {
                        deferred.resolve();
                    } else {
                        deferred.reject(data);
                    }
                }).error(function(data, status, headers, config) {
                    deferred.reject(data, status, headers, config);
                });
                return deferred.promise;
            },

            /**
             * @method getRecollectAddress
             * @desc Request the address that the order associated with the given activation code was shipped to.
             * @param {String} activationCode
             * @returns {Promise} The promise to be resolved or rejected.
             * @public
             */
            getRecollectAddress: function() {
                var deferred = $q.defer();
                var url = '/secure/tests/recollectAddress';

                $http.get(url).success(function(data) {
                    deferred.resolve(data);
                }).error(function(data, status) {
                    deferred.reject(status);
                });
                return deferred.promise;
            },

            getLastViewedTest: function() {
                return lastViewedTest;
            },

            setLastViewedTest: function(dataToStore) {
                lastViewedTest = dataToStore;
            },

            getDnaProcessingTimeEstimates: function(testGuid) {
                var deferred = $q.defer();
                var url = URL_DNA_PROCESSING_TIME_EST.replace(KEY_GUID, encodeURIComponent(testGuid));
                $http.get(url, {cache: testsServiceShortCache}).success(function(data) {
                    deferred.resolve(data);
                }).error(function() {
                    deferred.reject();
                });
                return deferred.promise;
            }

        };
    }
    ]);
});
